import { http } from '../../config/axios'

export default function putCampanha(campanha: any): Promise<string> {
  return http
    .put('api/campanha', campanha)
    .then((res) => res.data as string)
    .catch((error) => {
      console.error('Erro put campanha', error)
      throw Error(error.response.data)
    })
}
